import { APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { NgModule } from '@angular/core';

import { CoreModule } from './core/core.module';

import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LoginService } from './login/login.service';
import { AppConfig } from './app.config';
import { DashboardModule } from './dashboard/dashboard.module';
import { TrainingModule } from './training/training.module';

import { DeactivateGuardService } from './deactivate-guard.service';
import { LogoutComponent } from './logout/logout.component';

import { MsalModule, MSAL_INSTANCE, MsalService } from '@azure/msal-angular';
import { PublicClientApplication, IPublicClientApplication } from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { TokenInterceptor } from './core/auth';

const initConfig = (config: AppConfig) => () => {
    return new Promise((resolve) => {
        config.initialize().then(() => {
            resolve(true);
        });
    });
};

const isIE =
    window.navigator.userAgent.indexOf('MSIE ') > -1 ||
    window.navigator.userAgent.indexOf('Trident/') > -1;

export function MSALInstanceFactory(): IPublicClientApplication {
    var rootHost = document.location.host;
    if (rootHost.indexOf('.') >= 0) rootHost = 'www' + rootHost.substring(rootHost.indexOf('.'));

    environment.azureLoginCfg.redirectUri = document.location.protocol + '//' + rootHost;
    return new PublicClientApplication({
        auth: environment.azureLoginCfg,
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
        },
    });
}
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [AppComponent, LoginComponent, LogoutComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,

        // app modules below
        AppRoutingModule,
        CoreModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
            defaultLanguage: 'en',
        }),

        DashboardModule,
        TrainingModule,

        MsalModule,
    ],
    providers: [
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
        },
        MsalService,
        LoginService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        AppConfig,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [AppConfig],
            multi: true,
        },
        DeactivateGuardService,
        provideHttpClient(withInterceptorsFromDi()),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
